/**
 * Image with Product Section Script
 * 画像と商品セクション用JavaScript - 重複読み込み防止機能付き
 */

(function () {
  'use strict';

  // 重複実行防止フラグ
  if (window.imageWithProductInitialized) {
    return;
  }

  // 初期化フラグを設定
  window.imageWithProductInitialized = true;

  /**
   * セクションの初期化
   */
  function initializeImageWithProduct() {
    const slideshows = document.querySelectorAll('.image-with-product__slideshow');

    slideshows.forEach((slideshow) => {
      // 既に初期化済みかチェック
      if (slideshow.dataset.initialized === 'true') {
        return;
      }

      const slides = slideshow.querySelectorAll('.image-with-product__slide');
      const dots = slideshow.querySelectorAll('.image-with-product__dot');
      const autoPlay = slideshow.dataset.autoPlay === 'true';
      const duration = parseInt(slideshow.dataset.slideDuration) || 5000;

      if (slides.length <= 1) {
        slideshow.dataset.initialized = 'true';
        return;
      }

      let currentIndex = 0;
      let intervalId;

      /**
       * 指定されたインデックスのスライドを表示
       * @param {number} index - 表示するスライドのインデックス
       */
      function showSlide(index) {
        slides.forEach((slide, i) => {
          slide.classList.toggle('image-with-product__slide--active', i === index);
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('image-with-product__dot--active', i === index);
        });
        currentIndex = index;
      }

      /**
       * 次のスライドに移動
       */
      function nextSlide() {
        const nextIndex = (currentIndex + 1) % slides.length;
        showSlide(nextIndex);
      }

      /**
       * 自動再生を開始
       */
      function startAutoPlay() {
        if (autoPlay) {
          intervalId = setInterval(nextSlide, duration);
        }
      }

      /**
       * 自動再生を停止
       */
      function stopAutoPlay() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      // ドットクリックイベント
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          stopAutoPlay();
          showSlide(index);
          startAutoPlay();
        });
      });

      // ホバーで一時停止
      slideshow.addEventListener('mouseenter', stopAutoPlay);
      slideshow.addEventListener('mouseleave', startAutoPlay);

      // 自動再生開始
      startAutoPlay();

      // 初期化完了フラグを設定
      slideshow.dataset.initialized = 'true';
    });
  }

  /**
   * 新しく追加されたセクションを監視して初期化
   */
  function observeNewSections() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // 新しく追加されたセクションをチェック
            const newSlideshows = node.querySelectorAll ? node.querySelectorAll('.image-with-product__slideshow') : [];

            newSlideshows.forEach((slideshow) => {
              if (slideshow.dataset.initialized !== 'true') {
                // 個別のスライドショーを初期化
                initializeSingleSlideshow(slideshow);
              }
            });

            // 追加されたノード自体がスライドショーの場合
            if (node.classList && node.classList.contains('image-with-product__slideshow')) {
              if (node.dataset.initialized !== 'true') {
                initializeSingleSlideshow(node);
              }
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * 単一のスライドショーを初期化
   * @param {Element} slideshow - 初期化するスライドショー要素
   */
  function initializeSingleSlideshow(slideshow) {
    const slides = slideshow.querySelectorAll('.image-with-product__slide');
    const dots = slideshow.querySelectorAll('.image-with-product__dot');
    const autoPlay = slideshow.dataset.autoPlay === 'true';
    const duration = parseInt(slideshow.dataset.slideDuration) || 5000;

    if (slides.length <= 1) {
      slideshow.dataset.initialized = 'true';
      return;
    }

    let currentIndex = 0;
    let intervalId;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('image-with-product__slide--active', i === index);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('image-with-product__dot--active', i === index);
      });
      currentIndex = index;
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }

    function startAutoPlay() {
      if (autoPlay) {
        intervalId = setInterval(nextSlide, duration);
      }
    }

    function stopAutoPlay() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    // イベントリスナーを追加
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        stopAutoPlay();
        showSlide(index);
        startAutoPlay();
      });
    });

    slideshow.addEventListener('mouseenter', stopAutoPlay);
    slideshow.addEventListener('mouseleave', startAutoPlay);

    startAutoPlay();
    slideshow.dataset.initialized = 'true';
  }

  /**
   * モーダル内のスライドショーを初期化
   */
  function initializeModalSlideshows() {
    // モーダルが開かれた時にスライドショーを初期化
    document.addEventListener('modal:open', function (event) {
      const modal = event.target;
      if (modal && modal.classList.contains('modal--gallery')) {
        const slideshows = modal.querySelectorAll('.image-with-product__slideshow[data-modal-slideshow="true"]');
        slideshows.forEach((slideshow) => {
          if (slideshow.dataset.initialized !== 'true') {
            initializeSingleSlideshow(slideshow);
          }
        });
      }
    });

    // 既存のモーダル内スライドショーも初期化
    const modalSlideshows = document.querySelectorAll('.modal--gallery .image-with-product__slideshow[data-modal-slideshow="true"]');
    modalSlideshows.forEach((slideshow) => {
      if (slideshow.dataset.initialized !== 'true') {
        initializeSingleSlideshow(slideshow);
      }
    });
  }

  // DOM読み込み完了時に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeImageWithProduct();
      initializeModalSlideshows();
      observeNewSections();
    });
  } else {
    // 既にDOMが読み込まれている場合は即座に実行
    initializeImageWithProduct();
    initializeModalSlideshows();
    observeNewSections();
  }
})();
